import request from '@/network/http'

export function deleteUserInfo(data) {
    return request({
        url: 'Users/Users/deleteUserInfo',
        method: 'post',
        data
    })
}

export function getUserDetail(data) {
    return request({
        url: 'Users/Users/getUserDetail',
        method: 'post',
        data
    })
}

export function saveUserInfo(data) {
    return request({
        url: 'Users/Users/saveUserInfo',
        method: 'post',
        data
    })
}

export function getUserList(data) {
    return request({
        url: 'Users/Users/getUserList',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/apis/personManage.js